module.exports = __webpack_public_path__ + "img/logo-inverted.4091ac58.png";